import React, { useEffect, useState } from "react";
import { isVerified } from "../../../../../../utils/Helper";
import {
  Card,
  Input,
  Button,
  UploadingInput,
  InputDisable,
} from "../../../../../common";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as Close } from "../../../../../../assets/icons/close-circle.svg";
import {
  useCreateBankMutation,
  useCreateBankDraftMutation,
  useUpdateBankMutation,
  useUpdateBankDraftMutation,
} from "../../../../../../store/Company/companyApiSlice";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import useCompanyUpdate from "../useCompanyFollowUpdate";
import { uploadFilePath } from "../../../../../../constants/s3UploadPath";
import { uploadFileToS3 } from "../../../../../../utils/uploadFileToS3";

export const BankingDetail = ({
  onBankInfo,
  ibanNumber,
  editBank,
  modalHandle,
  refetch, compRefetch, dataChanged, setDataChanged
}) => {
  const [errors, setErrors] = useState({});

  const [uploadedFile, setUploadedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [progress, setProgress] = useState(50);
  const [bankInfo, setBankInfo] = useState();
  const renderPreview = () => {
    if (uploadedFile.type.includes("image")) {
      return <img src={previewImage} alt="trade" className="w-18" />;
    } else if (uploadedFile.type === "application/pdf") {
      return (
        <embed
          src={`${URL.createObjectURL(uploadedFile)}#page=1`}
          type="application/pdf"
          width="100%"
          height="500px"
        />
      );
    } else {
      return <p>Unsupported file type</p>;
    }
  };
  const { currentEditingCompany } = useSelector((state) => state.company);

  const { userInfo, token } = useSelector((state) => state.auth);
  const [createBankMutation, { isLoading }] = useCreateBankMutation();
  const [createBankMutationDraft, { isLoading: isCreatingDraft }] =
    useCreateBankDraftMutation();
  const [updateBankMutation, { isLoading: isUpdating }] =
    useUpdateBankMutation();
  const [updateBankMutationDraft, { isLoading: isUpdatingDraft }] =
    useUpdateBankDraftMutation();

  useEffect(() => {
    if (onBankInfo) {
      let bankData = {
        IBAN: onBankInfo?.data?.id,
        bank_name: onBankInfo?.data?.swift?.bank?.name,
        country: onBankInfo?.data?.country?.name,
        current_companyID: currentEditingCompany?.companyID,
      };

      setBankInfo(bankData);
    }
  }, []);

  useEffect(() => {
    if (editBank) {
      let bankData = {
        IBAN: editBank.IBAN,
        bank_name: editBank?.bank_name,
        country: editBank?.country,
        current_companyID: currentEditingCompany?.companyID,
        bankID: editBank?.bankID,
      };

      setBankInfo(bankData);
    }
  }, []);

  const handleFileSelect = (file) => {
    setUploadedFile(file);
    setProgress(100)
    if (file && file.type.match("image.*")) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };

      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
    }
  };

  function convertFileSize(size) {
    if (size < 1024) {
      return size + " B";
    } else if (size < 1024 * 1024) {
      return (size / 1024).toFixed(2) + " KB";
    } else {
      return (size / (1024 * 1024)).toFixed(2) + " MB";
    }
  }

  const handleUpdateCompany = useCompanyUpdate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const verifiedData = currentEditingCompany.verifiedCompany;

    if (isVerified(verifiedData)) {
      const formData = new FormData();
      formData.append("bank_name", bankInfo?.bank_name);
      formData.append("IBAN", bankInfo?.IBAN.toUpperCase());
      formData.append("country", bankInfo?.country);
      if (uploadedFile) {
        const bankConUrl = await uploadFileToS3(uploadFilePath?.bank, uploadedFile, token, userInfo?.id);
        formData.append("bank_conf_letter", bankConUrl?.url);
      }
      formData.append("current_companyID", currentEditingCompany?.companyID);
      try {
        let res;

        if (editBank && editBank?.bank_draftID) {
          formData.append("request_type", "Bank update draft request");
          if (editBank?.bankID != undefined && editBank?.bankID != null)
            formData.append("bankID", editBank?.bankID_id);
          res = await updateBankMutationDraft({
            data: formData,
            bankId: editBank?.bank_draftID,
            token,
          }).unwrap();
          if (res) {
            compRefetch();
            refetch()
            setDataChanged(!dataChanged);
            // window.location.reload();

          }
        } else {
          formData.append("request_type", "Bank Details create draft request");
          if (editBank?.bankID != undefined && editBank?.bankID != null)
            formData.append("bankID", editBank?.bankID);
          res = await createBankMutationDraft({
            data: formData,
            token,
          }).unwrap();
          if (res) {
            compRefetch();
            refetch()
            setDataChanged(!dataChanged);
            // window.location.reload();

          }
        }
      } catch (error) {
      } finally {
        modalHandle();
      }
    } else {
      const formData = new FormData();
      formData.append("bank_name", bankInfo?.bank_name);
      formData.append("IBAN", bankInfo?.IBAN.toUpperCase());
      formData.append("country", bankInfo?.country);
      if (uploadedFile) {
        const bankConUrl = await uploadFileToS3(uploadFilePath?.bank, uploadedFile, token, userInfo?.id);
        formData.append("bank_conf_letter", bankConUrl?.url);
      }

      try {
        let res;
        if (editBank) {
          res = await updateBankMutation({
            data: formData,
            bankId: bankInfo?.bankID,
            token,
          }).unwrap();
          const result = await handleUpdateCompany(
            currentEditingCompany.companyID,
            "Bank Information Updated",
            token
          );
          if (!result.success) {
            console.error(result.error);
          }
          if (result) {
            compRefetch();
            refetch()
            setDataChanged(!dataChanged);
            // window.location.reload();

          }
        } else {
          formData.append("current_companyID", bankInfo?.current_companyID);
          res = await createBankMutation({
            data: formData,
            token,
          }).unwrap();
          const result = await handleUpdateCompany(
            currentEditingCompany.companyID,
            "New Bank Added",
            token
          );
          if (!result.success) {
            console.error(result.error);
          }
          if (result) {
            compRefetch();
            refetch()
            setDataChanged(!dataChanged);
            // window.location.reload();

          }
        }
      } catch (error) {
      } finally {
        modalHandle();
      }
    }
  };

  return (
    <Card classes="rounded bg-white py-2 w-[32rem]">
      <div className="w-fit tracking-subheading text-secondarytwo font-bold text-f16  rounded-lg -mt-6 mb-7">
        Add Banking Information
      </div>

      <div className="">
        <label
          htmlFor="IBAN"
          className="block mb-1 text-primary text-f14 font-semibold text-left "
        >
          IBAN
        </label>
        <input
          value={bankInfo?.IBAN.toUpperCase()}
          className="focus:border-primary px-3 py-2 border-input rounded bg-input w-full border mb-2"
        />
        <InputDisable label="Bank Name" value={bankInfo?.bank_name} />
        <InputDisable label="Your Country" value={bankInfo?.country} />
        <label className="block mb-1 mt-5 text-primary text-f14 font-semibold text-left">
          Upload Bank Confirmation Letter
        </label>

        <UploadingInput onFileSelect={handleFileSelect} />
        {uploadedFile && (
          <div className="bg-slate mt-2 p-3 rounded-md relative ">
            <div className="flex gap-3">
              <div
                className={`flex-auto w-16 ${uploadedFile.type === "application/pdf" ? "h-20" : "h-14"
                  } overflow-hidden`}
              >
                {renderPreview()}
              </div>
              <div className="flex flex-col items-start justify-center text-secondarytwo">
                <p className="text-f14">{uploadedFile.name}</p>
                <div>
                  <span className="text-f12 text-secondary">
                    {convertFileSize(uploadedFile.size)}
                  </span>
                </div>
              </div>
            </div>
            {true && (
              <div className="flex gap-3 items-center justify-start mt-3">
                <div className="bg-white h-2 rounded-full overflow-hidden  relative w-full">
                  <div
                    className="bg-primary h-full transition-all"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
                <span className="">{progress}%</span>
              </div>
            )}

            {uploadedFile && (
              <button
                className="absolute right-3 top-3"
                onClick={() => setUploadedFile(null)}
              >
                <Close />
              </button>
            )}
          </div>
        )}
        {errors.tradePhotoError && (
          <p className="text-red-500 text-sm text-left">
            {errors.tradePhotoError}
          </p>
        )}

        <Button
          classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 flex justify-center"
          onClick={handleSubmit}
        >
          {isLoading || isUpdating || isCreatingDraft || isUpdatingDraft ? (
            <Spinner />
          ) : (
            "Submit"
          )}
        </Button>
        <div className="text-primaryText font-semibold text-f16 mt-5">
          Bank Not Found?{" "}
          <Link to="/dashboard/help" target="_blank" className="text-link">
            Contact Support
          </Link>
        </div>
      </div>
    </Card>
  );
};
